/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.Community || (M.Template.Community = {});
M.Template.Community.UserInfo || (M.Template.Community.UserInfo = {});

M.Template.Community.UserInfo.FeedbackWidgetDesignerInfo = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2016 Minted Inc.
   *
   * All Rights Reserved
   *
   *
   * CTAG:COMMUNITY:CHALLENGES
   */
__p+='\n<div class="userInfo floatL">\n  ';
 if (designerProfilePageUrl) { 
__p+='\n    <a href="'+
((__t=( M.html.htmlAttributeEscape(designerProfilePageUrl) ))==null?'':__t)+
'">\n      <img class="userProfileImg floatL"\n          src="'+
((__t=( M.html.htmlAttributeEscape(designerAvatarUrl) ))==null?'':__t)+
'">\n    </a>\n  ';
 } else { 
__p+='\n    <img class="userProfileImg floatL"\n        src="'+
((__t=( M.html.htmlAttributeEscape(designerAvatarUrl) ))==null?'':__t)+
'">\n  ';
 } 
__p+='\n  <div class="userInfoText floatL">\n    <div class="nameLabel truncate">\n      ';
 if (designerProfilePageUrl) { 
__p+='\n        <a class="nameLabel truncate"\n          href="'+
((__t=( M.html.htmlAttributeEscape(designerProfilePageUrl) ))==null?'':__t)+
'">\n          '+
((__t=( M.html.htmlEscape(designerName) ))==null?'':__t)+
'</a>\n      ';
 } else { 
__p+='\n        '+
((__t=( M.html.htmlEscape(designerName) ))==null?'':__t)+
'\n      ';
 } 
__p+='\n    </div>\n    <div class="text--quaternary truncate">'+
((__t=( M.html.htmlAttributeEscape(designerLocation) ))==null?'':__t)+
'</div>\n  </div>\n</div>';
}
return __p;
});

M.Template.Community.UserInfo.UserInfoBrief = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   *
   *
   * CTAG:COMMUNITY:ACTIVITY_FEED
   */
__p+='\n<div class="userInfo floatL">\n  ';
 if (userProfileUrl) { 
__p+='\n    <a href="'+
((__t=( M.html.htmlAttributeEscape(userProfileUrl) ))==null?'':__t)+
'">\n      <img class="userProfileImg floatL"\n          src="'+
((__t=( M.html.htmlAttributeEscape(userAvatarUrl) ))==null?'':__t)+
'">\n    </a>\n  ';
 } else { 
__p+='\n    <img class="userProfileImg floatL"\n        src="'+
((__t=( M.html.htmlAttributeEscape(userAvatarUrl) ))==null?'':__t)+
'">\n  ';
 } 
__p+='\n  <div class="userInfoText floatL">\n    <div class="nameLabel truncate">\n      ';
 if (userProfileUrl) { 
__p+='\n        <a class="nameLabel truncate"\n          href="'+
((__t=( M.html.htmlAttributeEscape(userProfileUrl) ))==null?'':__t)+
'">\n          '+
((__t=( M.html.htmlEscape(userName) ))==null?'':__t)+
'</a>\n      ';
 } else { 
__p+='\n        '+
((__t=( M.html.htmlEscape(userName) ))==null?'':__t)+
'\n      ';
 } 
__p+='\n    </div>\n    <div class="text--quaternary truncate">'+
((__t=( M.html.htmlAttributeEscape(userLocation) ))==null?'':__t)+
'</div>\n  </div>\n</div>';
}
return __p;
});


return {};

});
/* end templito generated file */
